<style lang="stylus">
    .browserModal-mask
        modal-mask()
        z-index 120
        .browserModal-box
            width 480px
            max-width 100%
            background-color #fff
            border-radius $box-radius
            .browserModal-header
                font-weight bold
                padding 12px 24px
                display flex
                font-size 14px
                color #222
                align-items center
                user-select none
                .header-close
                    position absolute
                    display flex
                    align-items center
                    justify-content center
                    width 24px
                    height 24px
                    top 8px
                    right 8px
                    cursor pointer
                    border-radius 6px
                    &:hover
                        background rgba(0,0,0,0.06)
                    svg
                        width 10px
                        height 10px
            .browserModal-content
                .content-box
                    position relative
                    color #222
                    border 1px solid rgba(0, 0, 0, 0.06)
                    border-radius 6px
                    padding 8px 12px
                    min-height 150px
                    max-height 250px
                    overflow auto
                    .loading-ring
                        position absolute
                        left 0
                        right 0
                        top 0
                        bottom 0
                        margin auto
                        padding 12px 16px
                        width fit-content
                        height 48px
                        display flex
                        justify-content center
                        align-items center
                        background var(--bg-color-tips);
                        border 0.5px solid rgba(0, 0, 0, 0.05);
                        /* Note: backdrop-filter has minimal browser support */
                        backdrop-filter: blur(2px);
                        border-radius: 8px;
                        svg
                            animation ani-load-loop 0.8s linear infinite
                        .loading-text
                            color white
                            margin-left 8px
                    // 使节点的三角形图标自身点击事件失效，触发 node-click 方法
                    .el-tree-node__expand-icon
                        pointer-events none
            .browserModal-footer
                padding 0 24px 24px
                display flex
                justify-content flex-end
                .btn
                    color #000
                    background-color #ebedf1
                    width fit-content
                    padding 5px 24px
                    margin-left 16px
                    border none
                    border-radius 6px
                    cursor pointer
                    span
                        vertical-align baseline
                    &.btn-primary
                        color #fff
                        background-color var(--themeColor)
                    &.disabled
                        cursor not-allowed
                        color #c5c8ce
                        background-color #f7f7f7
                        border-color #dcdee2
                    &:hover
                        background-color #dddfe3
                        &.btn-primary:hover
                            background-color var(--themeHover)
                        &.disabled:hover
                            cursor not-allowed
                            color #c5c8ce
                            background-color #f7f7f7
                            border-color #dcdee2
</style>

<template>
    <EDModal class="browserModal-mask" ref="modal">
        <div class="browserModal-box">
            <div class="browserModal-content">
                <div class="content-box" v-if="folderLoding">
                    <div class="loading-ring">
                        <svg id="loader-1" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_2292_53134)">
                                <!-- prettier-ignore -->
                                <path opacity="0.2" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="white" stroke-width="2.5"/>
                                <path d="M22 12C22 6.47715 17.5228 2 12 2" stroke="white" stroke-width="2.5" stroke-linecap="round" />
                            </g>
                            <!-- prettier-ignore -->
                            <defs><clipPath id="clip0_2292_53134"><rect width="24" height="24" fill="white" /></clipPath></defs>
                        </svg>
                        <p class="loading-text">{{ $t("loading") }}</p>
                    </div>
                </div>
                <ed-tree
                    v-else
                    class="content-box"
                    node-key="key"
                    :data="renderList"
                    :current-node-key="currentNode"
                    @node-click="handleNodeClick"
                    default-expand-all
                    highlight-current
                ></ed-tree>
            </div>
        </div>
    </EDModal>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";

    @Component
    export default class FolderModal extends Vue {
        @Prop() title;
        @Prop({ default: false }) isFolder: boolean;
        @Prop() selectFolder: any;
        @Prop({ default: false }) showActionBtn: boolean;

        foldersList = [];
        folderLoding = false;
        defaultCurrent = 0;

        get renderList() {
            let rootPath = [
                {
                    label: this.$t("personal"),
                    prefix: "",
                    children: this.foldersList,
                },
            ];
            return this.folderLoding ? [] : rootPath;
        }
        get selectMovePrefix() {
            return this.$store.state.selectMovePrefix;
        }
        set selectMovePrefix(v) {
            this.$store.commit("setState", {
                type: "selectMovePrefix",
                data: v,
            });
        }
        get moveLoading() {
            return this.$store.state.cloudFile.moveLoading;
        }
        get copyLoading() {
            return this.$store.state.cloudFile.copyLoading;
        }
        get path() {
            return this.$store.state.cloudFile.path;
        }
        get userInfo() {
            return this.$store.state.userInfo;
        }
        // 首次打开时默认选中项（高亮）
        get currentNode() {
            return this.selectMovePrefix ? this.defaultCurrent : 0;
        }
        // 为文件夹树结构设置key
        @Watch("renderList", { deep: true })
        setListKey(newList) {
            let index = 0;
            const setKey = (list) => {
                list.map((item) => {
                    this.$set(item, "key", index++);
                    if (item.defaultCurrent) {
                        this.defaultCurrent = item.key;
                    }
                    const hasChild = item.children && item.children.length;
                    if (hasChild) setKey(item.children);
                });
            };
            setKey(newList);
        }
        close() {
            this.$emit("closeModal");
        }
        getFolder() {
            this.folderLoding = true;
            let prefix = "";
            if (this.path.length) {
                // 定位三层下的目录传参需要截断
                let pathPrefix = this.path.length > 3 ? this.path.slice(0, 3) : this.path;
                prefix = pathPrefix.join("/") + "/";
            }
            this.selectMovePrefix = prefix && this.currentNode ? this.userInfo.user_name + "/Personal/" + prefix : "";
            this.$store
                .dispatch("getFolders", { prefix })
                .then((res) => {
                    let folderList = res.data.data || [];
                    let setItems = (arr) => {
                        let list = arr; // 以便修改原数组
                        // 复制、移动文件夹时，屏蔽自身目录
                        if (this.isFolder) {
                            list = list.filter((v) => {
                                return v.path != this.selectFolder.prefix;
                            });
                        }
                        list.map((item) => {
                            let list = item.path.split("/");
                            item.prefix = item.path;
                            item.label = list[list.length - 2];
                            if (!this.isFolder && item.is_from_folder) {
                                // 默认选中文件的所在的目录（最大支持3层）
                                item.defaultCurrent = !!item.is_from_folder;
                            }
                            // 接口返回的最子级，设置动态加载（展示三角箭头）
                            if (item.level == 2) {
                                item.children = [];
                                item.showExpand = true;
                            }
                            // 深度遍历
                            if (item.children) {
                                item.children = setItems(item.children);
                            }
                        });
                        return list;
                    };
                    this.foldersList = setItems(folderList);
                })
                .finally(() => {
                    this.folderLoding = false;
                });
        }
        handleNodeClick(curObj, node, self) {
            this.selectMovePrefix = curObj.prefix;
            // 选中项有子目录时，不请求数据
            if (curObj.children && curObj.children.length) return;
            // 异步加载数据
            let prefix = curObj.prefix.split("/").slice(2).join("/");
            if (this.isPrivate) prefix = curObj.prefix;
            this.$store.dispatch("getFloder", { prefix }).then((res) => {
                let folderList = res.data.data.folders;
                if (folderList) {
                    // 复制、移动文件夹时，屏蔽自身目录
                    if (this.isFolder) {
                        folderList = folderList.filter((v) => {
                            return v.prefix != this.selectFolder.prefix;
                        });
                    }
                    folderList.map((item) => {
                        let list = item.prefix.split("/");
                        item.label = list[list.length - 2];
                        item.children = [];
                        // 动态加载的子目录默认展示箭头
                        item.showExpand = true;
                    });
                    this.$set(curObj, "children", folderList);
                } else {
                    // 实际请求无子目录时隐藏箭头
                    this.$set(curObj, "showExpand", false);
                }
            });
        }
        confirm() {
            if (this.folderLoding) return;
            this.$emit("confirm");
        }
        actionConfirm(type) {
            if (this.folderLoding) return;
            this.$emit("actionConfirm", type);
        }
        escClose(e) {
            if (e.keyCode == 27) {
                this.close();
            }
        }
        created() {
            this.getFolder();
            document.addEventListener("keydown", this.escClose);
        }
        beforeDestroy() {
            document.removeEventListener("keydown", this.escClose);
        }
        mounted() {
            let dom = this.$refs.modal as any;
            dom.show({
                title: this.title,
                useDark: this.isPCDarkMode,
                isPC: this.isPC,
                confirmText: this.showActionBtn ? this.$tc("move") : this.$tc("confirm"),
                cancelText: this.showActionBtn ? this.$tc("copy") : this.$tc("cancel"),
                confirmEvent: () => {
                    if (this.showActionBtn) {
                        this.actionConfirm("move");
                    } else {
                        this.confirm();
                    }
                },
                closeEvent: () => {
                    if (this.showActionBtn) {
                        this.actionConfirm("copy");
                    } else {
                        this.close();
                    }
                },
                trueCloseEvent: () => {
                    this.close();
                },
            });
        }
    }
</script>
<i18n>
{
    "zh": {
        "personal": "我的文件",
        "loading": "加载中...",
        "noData": "暂无数据",
        "copy": "复制",
        "move": "移动",
        "confirm": "确认",
        "cancel": "取消"
    },
    "en": {
        "personal": "My Documents",
        "loading": "loading...",
        "noData": "No Data",
        "copy": "Copy",
        "move": "Move",
        "confirm": "OK",
        "cancel": "Cancel"
    },
    "fr": {
        "personal": "Cloud personnel",
        "loading": "chargement...",
        "noData": "Aucune donnée",
        "copy": "Copie",
        "move": "Mobile",
        "confirm": "Confirmer",
        "cancel": "Annuler"
    },
    "de": {
        "personal": "Persönlicher Cloud",
        "loading": "Wird geladen...",
        "noData": "Keine Einträge",
        "copy": "Kopieren",
        "move": "Mobiltelefon",
        "confirm": "Sichern",
         "cancel": "Abbrechen"
    },
    "jp": {
        "personal": "個人クラウド",
        "loading": "読み込み中...",
        "noData": "データなし",
        "copy": "コピー",
        "move": "モバイル",
        "confirm": "確認",
        "cancel": "キャンセル"
    },
    "es": {
        "personal": "Nube Personal",
        "loading": "cargando...",
        "noData": "Sin Datos",
        "copy": "Copiar",
        "move": "móvil",
        "confirm": "Aceptar",
        "cancel": "Cancelar"
    },
    "pt": {
        "personal": "Pessoal",
        "loading": "Carregando...",
        "noData": "Sem dados",
        "copy": "cópia de",
        "move": "Móvel",
        "confirm": "OK",
        "cancel": "Cancelar"
    },
    "it": {
        "personal": "Personali",
        "loading": "Caricamento in corso...",
        "noData": "Nessun dato",
        "copy": "copia",
        "move": "mobile",
        "confirm": "OK",
        "cancel": "Annulla"
    },
    "tw": {
        "personal": "個人雲端硬碟",
        "loading": "加載中...",
        "noData": "暫無數據",
        "copy": "複製",
        "move": "移動",
        "confirm": "確認",
        "cancel": "取消"
    },
    "kr": {
        "personal": "개인 클라우드",
        "loading": "로딩중...",
        "noData": "데이터 없음",
        "copy": "복사",
        "move": "이동",
        "confirm": "확인",
        "cancel": "취소"
    }
}
</i18n>
